<template>
  <TypesTable />
</template>

<script lang="ts" setup>
import TypesTable from '@/components/deepbox/types/TypesTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.personal.my_private_sections',
  },
})
</script>
